import LogoutIcon from '@/assets/icons/logout.svg?react';
import { logout } from '@/features/auth/authSlice';
import { IconButton } from '@/lib';
import { useAppDispatch } from '@/reducers';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

export const LogoutButton: FC = () => {
  const dispatch = useAppDispatch();

  const onLogoutClicked = () => {
    dispatch(logout());
  };

  return (
    <IconButton
      onClick={onLogoutClicked}
      intent='link-grey'
      leadingIcon={<LogoutIcon className='size-5' />}
      className={twMerge(
        'm-1.5 mt-0',
        'motion-safe:transition-opacity motion-safe:delay-200 motion-safe:duration-500 motion-reduce:transition-none',
        'group-data-[expanded=false]/sidebar:opacity-0 group-data-[expanded=false]/sidebar:motion-safe:delay-0 group-data-[pinned=true]/sidebar:motion-safe:delay-0'
      )}
    />
  );
};
